import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tratos',
  templateUrl: './tratos.component.html',
  styleUrls: ['./tratos.component.css']
})
export class TratosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/tratos/tratos.component.ts